<template>
  <b-modal id="employee-create-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow" no-close-on-backdrop>
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ $t('admin.create_employee') }}</span>
      </div>
    </template>

    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template v-if="!isLoading">
      <div class="adp-modal-row" >
        <div class="adp-p adp-p__grey">{{ $t('admin.id') }}</div>
        <input type="text" v-model="pernumber" class="adp-input adp-input__text">
      </div>

      <div class="adp-modal-row" >
        <div class="adp-p adp-p__grey">{{ $t('admin.fio') }}</div>
        <input type="text" v-model="fullname" class="adp-input adp-input__text">
      </div>

      <div class="adp-modal-row" >
        <div class="adp-p adp-p__grey">{{ $t('admin.phone') }}</div>
        <input type="text" v-model="phone" class="adp-input adp-input__text">
      </div>

      <div class="adp-modal-row" >
        <div class="adp-p adp-p__grey">{{ $t('admin.email') }}</div>
        <input type="text" v-model="email" class="adp-input adp-input__text">
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.be') }}</label>
        <v-select :options="companyOptions" :clearable="false" v-model="company" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.office') }}</label>
        <v-select :options="departmentOptions" :clearable="false" v-model="department" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.subdivision') }}</label>
        <v-select :options="subdivisionOptions" :clearable="false" v-model="subdivision" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.subdivision2') }}</label>
        <v-select :options="nullableSubdivisionOptions" :clearable="false" v-model="subdivision2" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.subdivision3') }}</label>
        <v-select :options="nullableSubdivisionOptions" :clearable="false" v-model="subdivision3" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.subdivision4') }}</label>
        <v-select :options="nullableSubdivisionOptions" :clearable="false" v-model="subdivision4" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.subdivision5') }}</label>
        <v-select :options="nullableSubdivisionOptions" :clearable="false" v-model="subdivision5" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.employee_type') }}</label>
        <v-select :options="employeeTypeOptions" :clearable="false" v-model="employeeType" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.position') }}</label>
        <v-select :options="positionOptions" :clearable="false" v-model="position" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>
    </template>
    <template #modal-footer>
      <button id="save" class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" @click="create()"
      :disabled="!pernumber || !fullname || !phone || !email || !company || !department
      || !subdivision || !subdivision2 || !subdivision3 || !subdivision4 || !subdivision5 || !position || !employeeType">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import api from "../../api";

export default {
  name: "EmployeeCreateModal",
  components: {
  },
  data: function () {
    return {
      isLoading: false,

      pernumber: null,
      fullname: null,
      phone: null,
      email: null,
      company: null,
      department: null,
      subdivision: null,
      subdivision2: null,
      subdivision3: null,
      subdivision4: null,
      subdivision5: null,
      position: null,
      employeeType: null,

      editableEmployee: {},

      companyOptions: [],
      departmentOptions: [],
      subdivisionOptions: [],
      nullableSubdivisionOptions: [],
      positionOptions: [],
      employeeTypeOptions: [],
    }
  },
  computed: {
  },
  watch: {
    company(newVal) {
      this.department = null;
      this.departmentOptions = window.IDP.departmens
        .filter(x => x.company_id === newVal)
        .map(x => ({code: x.id, label: x.name}));
    },
    department() {
      this.subdivision = null;
    },
  },
  methods: {
    async onShow() {
      this.isLoading = true;

      this.pernumber = null;
      this.fullname = null;
      this.phone = null;
      this.email = null;
      this.company = null;
      this.department = null;
      this.subdivision = null;
      this.position = null;
      this.reservist = null;
      this.group = null;
      this.level = null;
      this.companyOptions = Object.keys(window.IDP.companies).map(x => ({code: window.IDP.companies[x], label: x}));
      this.subdivisionOptions = Object.keys(window.IDP.subdivisions)
        .map(x => ({code: window.IDP.subdivisions[x], label: x}))
        .filter(x => x.code !== null && x.label !== '');
      this.nullableSubdivisionOptions = [...this.subdivisionOptions, {code: 'no', label: 'Нет'}];
      this.positionOptions = window.IDP.positions.map(x => ({code: x, label: x}));
      this.employeeTypeOptions = Object.keys(window.IDP.employee_types)
        .map(x => ({code: window.IDP.employee_types[x], label: this.$t(`voc.${window.IDP.employee_types[x]}`)}));

      this.isLoading = false;
    },
    async create() {
      const data = {
        'pernumber': this.pernumber,
        'name': this.fullname,
        'phone': this.phone,
        'email': this.email,
        'company': this.company,
        'department': this.department,
        'subdivision': this.subdivision,
        'subdivision2': this.subdivision2 === 'no' ? null : this.subdivision2,
        'subdivision3': this.subdivision3 === 'no' ? null : this.subdivision3,
        'subdivision4': this.subdivision4 === 'no' ? null : this.subdivision4,
        'subdivision5': this.subdivision5 === 'no' ? null : this.subdivision5,
        'fired_at': '9000-01-01',
        'position_name': this.position,
        'can_edit_catalog': null,
        'employee_type': this.employeeType,
      }

      try {
        let resp = await api.createEmployee(data);
        if (resp.status === 201) {
          this.$bvModal.hide('employee-create-modal');
          this.$emit('employee-created');
        }
      } catch (e) {
        console.error(e.response.data);
        const serverErrors = Object.keys(e.response.data.errors).map(x => `• ${this.$t('catalog.' + x)}`).join('\n');
        const errorText = this.$t('modal.error_add_employee_1') + '\n' +
          this.$t('modal.error_individual_modal_2') + '\n\n' +
          this.$t('modal.error_individual_modal_3') + '\n\n' +
          serverErrors;
        this.$toasts.error(errorText, {
          duration: 700000,
        });
      }
    },
  },
  mounted() {
  }
}
</script>
